import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { reference } from '@popperjs/core';

@Component({
  selector: 'app-realisation-indicateurs',
  templateUrl: './realisation-indicateurs.component.html',
  styleUrl: './realisation-indicateurs.component.scss'
})


export class RealisationIndicateursComponent {

  @ViewChild('realisationModal') modalContent: TemplateRef<any>;

  submitted: boolean;

  cibleindicateurItems: any = [];

  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  planification: Planification = new Planification()
  items: any;
  annees: number[] = [];
  ecartColor: string = 'black'; // Couleur par défaut
  ecart: number = 0;
  ecart_trim1: number = 0;
  ecart_trim2: number = 0;
  ecart_trim3: number = 0;
  ecart_trim4: number = 0;

  ecartColorTrim1: string = '';
  ecartColorTrim2: string = '';
  ecartColorTrim3: string = '';
  ecartColorTrim4: string = '';
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,

  ) {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.annees.push(currentYear + i);
    }
  }

  ngOnInit(): void {
    this.fetchDataIndicateur();
  }

  fetchDataIndicateur() {

    const resquestData = {
      annee: this.localstorage.getExerciceToUserToSuivieEvaluation(),
    }
    this.isLoading = true;
    this.paramservice.getValeurCible(resquestData).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.cibleindicateurItems = response.data;
        this.totalRecords = this.cibleindicateurItems.length
        this.updatePagination();

      },
      (error:any) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message || 'une erreur est survenu', life: 3000 });
      }

    );
  }


  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }

  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.cibleindicateurItems.slice(start, end);
  }

  //
  confirm1(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir continuer ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: 'Vous avez acepter' });

        this.paramservice.deleteIndicateur(event).subscribe(

          (response: any) => {

          },
          (error) => {

          },
        )
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }


  openRealisation(item: any) {
    this.items = item;

    console.log("this.items", this.items);

    this.planification.valeur_cible_id = this.items.id;
    // this.planification.annee = this.items.annee;
    // this.planification.indicateur_id=this.items.indicateur.reference;
    // this.planification.valeur_realisee = this.items.valeur_realisee   ; */

    ////console.log(" this.planification.valeur_realisee",  this.planification.valeur_realisee);
    // this.calculerEcart();
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }


  calculerEcart() {
    if (this.items.valeur_cible != null) {

      // Trim 1
      this.ecart_trim1 = (this.planification.valeur_realisee_trim1 || 0) - this.items.valeur_cible;
      this.ecartColorTrim1 = this.getColor(this.ecart_trim1);

      // Trim 2
      this.ecart_trim2 = (this.planification.valeur_realisee_trim2 || 0) - this.items.valeur_cible;
      this.ecartColorTrim2 = this.getColor(this.ecart_trim2);

      // Trim 3
      this.ecart_trim3 = (this.planification.valeur_realisee_trim3 || 0) - this.items.valeur_cible;
      this.ecartColorTrim3 = this.getColor(this.ecart_trim3);

      // Trim 4
      this.ecart_trim4 = (this.planification.valeur_realisee_trim4 || 0) - this.items.valeur_cible;
      this.ecartColorTrim4 = this.getColor(this.ecart_trim4);
    }
  }

  getColor(ecart: number): string {
    if (ecart > 0) return 'green';
    if (ecart < 0) return 'red';
    return 'blue';
  }

  saveRealisation() {

    // if (!this.planification.annee) {
    //   this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Veuillez séléctionner l'année" });
    //   return;
    // }

    if (this.planification.valeur_realisee_trim1 == null) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: "Veuillez saisir la valeur du 1er trimestre"
      });
      return;
    }

    if (this.planification.valeur_realisee_trim2 == null) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: "Veuillez saisir la valeur du 2ème trimestre"
      });
      return;
    }

    if (this.planification.valeur_realisee_trim3 == null) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: "Veuillez saisir la valeur du 3ème trimestre"
      });
      return;
    }

    if (this.planification.valeur_realisee_trim4 == null) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: "Veuillez saisir la valeur du 4ème trimestre"
      });
      return;
    }

    this.ngxService.start();
    this.paramservice.updateValeurcibleTorealiser(this.planification).subscribe(
      (response: any) => {
        ////console.log("la réponse du webservice", response);
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message
        });
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.fetchDataIndicateur();
      },
      (error: any) => {
        ////console.log("une erreu et survenu", error);
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error.error.message || 'une erreur est survenue'
        });
        this.ngxService.stop();

      }
    )

  }
}
export class Planification {
  annee: any;
  valeur_realisee_trim1: any;
  valeur_realisee_trim2: any;
  valeur_realisee_trim3: any;
  valeur_realisee_trim4: any;
  valeur_cible_id: any
  indicateur_id: any


}